(ns nosco.ui.user-menubar
  (:require
   [goog.functions :as gfunctions]
   ["react" :as React]
   [hx.react :refer [defnc]]
   ["react-useportal" :default usePortal]
   [nosco.icons2 :as icons2]
   [nosco.ui.text :as text]
   [nosco.react :as nosco-react]
   [hx.hooks :as hooks]))

(defnc MenuBar [{:keys [children]}]
  [:div {:class ["nosco-user-menubar"]}
   children])

(defnc MenuLink [{:keys [icon label selected] :as props}]
  [:a
   (-> {:title label
        :class ["nosco-user-menubar__link"
                (when selected "nosco-user-menubar__link--selected")]}
       (nosco-react/merge-props (dissoc props :icon :label :selected)))
   [:span
    [icons2/Icon {:icon icon}]]])

(defnc MenuButton [{:keys [icon label selected] :as props}]
  [:button
   (-> {:title label
        :class ["nosco-user-menubar__link"
                "nosco-button-reset"
                (when selected "nosco-user-menubar__link--selected")]}
       (nosco-react/merge-props (dissoc props :icon :label :selected)))
   [:span
    [icons2/Icon {:icon icon}]]])


(defn- use-scroll-direction-showing []
  (let [height (hooks/useMemo (fn []
                                (.-innerHeight js/window)))
        [showing set-showing] (hooks/useState true)
        on-scroll (fn [e]
                    (let [scrolly (.-scrollY js/window)]
                      (set-showing (< scrolly (* height 0.5)))))]
    (hooks/useEffect
     (fn []
       (.addEventListener js/window "scroll" on-scroll #js {:passive true})
       (fn []
         (.removeEventListener js/window "scroll" on-scroll)))
     [])

    showing))

(defonce ScrollDirectionShowingContext (React/createContext true))

(defnc ScrollDirectionShowingProvider [{:keys [children]}]
  (let [showing (use-scroll-direction-showing)]
    [:provider {:value showing
                :context ScrollDirectionShowingContext}
     children]))

(defnc StickyMenuBar [{:keys [children floating-above]}]
  (let [showing (hooks/useContext ScrollDirectionShowingContext)]
    [(.-Portal (usePortal))
     [:div {:class "nosco-sticky-menu-bar"}
      (when floating-above
        [:div {:class "nosco-user-menubar__floating-above"}
         (floating-above showing)])
      children]]))
